export default "__VITE_ASSET__Bp9wdi0Y__"